// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search_wrapper__2hd-T","input":"search_input__3EsJ0","label":"search_label__2aIZY","error":"search_error__2C4dC"};